import { Component, Input, OnInit } from '@angular/core';
import { genericFormI } from 'src/app/util/interfaces/genericFormRMK';
import { DefaultUrgencyService, searchDefaultUrgencyDTO } from './service/default-urgency.service';
import { requestClassificationInterface, urgencyInterface } from 'src/app/util/interfaces/requestClassification';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { customerInterface } from 'src/app/util/interfaces/customer';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { forkJoin } from 'rxjs';
import { NotificationService } from 'src/app/services/notification/notification.service';

@Component({
	selector: 'register-default-urgency',
	templateUrl: './default-urgency.component.html',
	styleUrl: './default-urgency.component.scss',
})
export class DefaultUrgencyComponent implements OnInit {
	@Input()
	labels = {
		lbl_geral_competencia: 'Scope',
		lbl_geral_natureza: 'Category',
		lbl_geral_topico: 'Topic',
		lbl_urgencia_padrao: 'Default Urgency',
		lbl_geral_pesquisar: 'Search',
		lbl_geral_cliente: 'Customer',
		lbl_geral_urgencia: 'Urgency',
		lbl_geral_salvar: 'Save',
		lbl_nao_necessario_preencher_todos_campos_busca: '',
		lbl_salvo_com_sucesso: '',
	};

	searchForm: genericFormI[] = [];

	classificationOptions = {
		isEditingClassification: true,
		disabled: false,
		selectedCustomer: null,
		lockField: [],
		hideField: ['impact', 'urgency', 'severity'],
		alertField: [],
		initOn: 'solution_area',
		thisAnalystOnly: false,
		hideServiceType: [],
	};

	constructor(
		private DefaultUrgencyService: DefaultUrgencyService,
		private LabelsService: LabelsService,
		private NotificationService: NotificationService,
		public ProfileService: ProfileService
	) {}

	isLoadingAvailableCustomer = true;
	isLoadingAvailableUrgencies = false;
	isLoadingClassification = false;

	isSearching = false;
	isSaving = false;

	availableCustomers: customerInterface[] = [];
	availableCustomersIAC: iacOptionInterface[] = [];
	selectedCustomer: iacOptionInterface = { name: '', value: '' };
	searchClassification: requestClassificationInterface;

	availableUrgencies: urgencyInterface[] = [];
	classificationArr: searchDefaultUrgencyDTO[] = [];

	ngOnInit(): void {
		this.ProfileService.getAvailableCustomers().subscribe({
			next: (customers) => {
				this.availableCustomers = customers;
				for (const customer of this.availableCustomers) {
					const newIAC: iacOptionInterface = {
						name: customer.customer,
						value: customer.id,
					};
					this.availableCustomersIAC.push(newIAC);
				}
			},
			complete: () => {
				this.selectedCustomer.value = this.ProfileService.userData().idCustomer;
				this.selectedCustomer.name = this.ProfileService.userData().customer;
				this.isLoadingAvailableCustomer = false;
			},
		});
		this.resetSearchClassification();
	}

	setSearchClassification(classificationEvent: any): void {
		classificationEvent = JSON.parse(classificationEvent);
		this.resetSearchClassification();
		this.searchClassification.solutionArea = classificationEvent.solutionArea;
		this.searchClassification.serviceType = classificationEvent.serviceType;
		this.searchClassification.scope = classificationEvent.scope;
		this.searchClassification.category = classificationEvent.category;
		this.searchClassification.topic = classificationEvent.topic;
	}

	resetSearchClassification(): void {
		this.searchClassification = {
			serviceType: [],
			scope: [],
			category: [],
			topic: [],
			solutionArea: [],
			impact: [],
			urgency: [],
			severity: [],
		};
	}

	search(): void {
		if (this.isSearching == true || this.isLoadingClassification == true) return;

		this.isSearching = true;
		forkJoin([
			this.DefaultUrgencyService.getAvailableUrgencies(this.selectedCustomer.value),
			this.DefaultUrgencyService.searchClassifications(this.searchClassification),
		]).subscribe({
			next: (forkRes) => {
				const availableUrgenciesRes = forkRes[0];
				const searchRes = forkRes[1];

				this.availableUrgencies = availableUrgenciesRes;
				this.classificationArr = searchRes;
			},
			complete: () => {
				this.isSearching = false;
			},
		});
	}

	saveDefaultUrgency(): void {
		if (this.isSaving == true || this.isLoadingClassification == true) return;
		this.isSaving = true;
		const saveClassification: searchDefaultUrgencyDTO[] = [];
		for (const classification of this.classificationArr) {
			if (classification.defaultUrgency != 'N/A') saveClassification.push(classification);
		}
		this.DefaultUrgencyService.saveDefaultUrgency(saveClassification).subscribe({
			next: () => {
				this.NotificationService.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
			},
			complete: () => {
				this.isSaving = false;
			},
		});
	}
}
